import { Language } from './base';

const pdash = () => import('../translations/pdash/de-DE.json');
const webActivities = () => import('../translations/web-activities/de-DE.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/de-DE.json');

export default new Language({
    code: 'de-DE',
    locale: 'de',
    localName: 'Deutsch',
    englishName: 'German',
    territory: 'DE',
    timezones: ['Europe/Berlin', 'Europe/Busingen'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
